import React from "react";
import Header from "../../components/header";
import heroBg from "../../images/image 35.svg";
import ndicFrame from "../../images/Frame 2147225101.svg";

const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const HomeMain = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.home-hero {
						min-height: 100svh !important;
						min-height: 844px !important;
					}
					.home-hero-bg {
						object-position: 70% top !important;
					}
					.home-hero-content {
						top: 302px !important;
						left: 24px !important;
						width: calc(100% - 48px) !important;
						gap: 32px !important;
					}
					.home-hero-text-block {
						gap: 40px !important;
					}
					.home-hero-heading {
						font-size: 42px !important;
						line-height: 115% !important;
						letter-spacing: -0.01em !important;
					}
					.home-hero-subtitle {
						font-size: 14px !important;
						line-height: 32px !important;
					}
					.home-hero-ndic {
						width: min(328px, 100%) !important;
					}
					.home-hero-buttons a {
						height: 44px !important;
						font-size: 14px !important;
					}
				}
			`}</style>

			<section
				className="home-hero"
				style={{
					width: "100%",
					minHeight: "clamp(600px, 71.1vw, 1024px)",
					backgroundColor: "#1A2A1A",
					position: "relative",
					overflow: "hidden",
				}}
			>
				{/* Full-cover background */}
				<img
					src={heroBg}
					alt=""
					aria-hidden="true"
					className="home-hero-bg"
					style={{
						position: "absolute",
						inset: 0,
						width: "100%",
						height: "100%",
						objectFit: "cover",
						objectPosition: "center top",
						filter: "brightness(1.12) saturate(1.03)",
						zIndex: 0,
					}}
				/>

				<Header />

				{/* Hero content */}
				<div
					className="home-hero-content"
					style={{
						position: "absolute",
						top: "clamp(80px, 11.1vw, 160px)",
						left: "clamp(20px, 5.56vw, 80px)",
						width: "clamp(280px, 49.2vw, 709px)",
						display: "flex",
						flexDirection: "column",
						gap: "clamp(24px, 2.78vw, 40px)",
						zIndex: 1,
					}}
				>
					<div
						className="home-hero-text-block"
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "clamp(28px, 3.33vw, 48px)",
							width: "100%",
						}}
					>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "clamp(8px, 0.83vw, 12px)",
									width: "100%",
								}}
							>
							{/* Label */}
							<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
								<span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#86C7A8", flexShrink: 0, display: "inline-block" }} />
									<span
										style={{
											fontFamily: "'Geist Mono', monospace",
											fontWeight: 500,
											fontSize: "14px",
											lineHeight: "1.2",
											letterSpacing: "0.08em",
											color: "#86C7A8",
											textTransform: "uppercase",
											whiteSpace: "nowrap",
									}}
								>
									banking for everyone
								</span>
							</div>

							<h1
								className="home-hero-heading"
								style={{
									...instrumentSerif,
									fontWeight: 400,
									fontSize: "clamp(28px, 5.56vw, 80px)",
									lineHeight: "130%",
									letterSpacing: "-0.01em",
									color: "#FFFFFF",
									margin: 0,
								}}
							>
								Your business<br />
								deserves a bank that<br />
								<span style={{ fontStyle: "italic", color: "#86C7A8" }}>understands</span> your needs.
							</h1>

							<p
								className="home-hero-subtitle"
								style={{
									fontFamily: "'Geist', sans-serif",
									fontWeight: 500,
									fontSize: "clamp(14px, 1.39vw, 20px)",
									lineHeight: "1.6",
									letterSpacing: 0,
									color: "#DEDEDE",
									margin: 0,
								}}
							>
								Banking built for the everyday people, Ndi Anyi. Ego Anyi. Oru Anyi.<br />
								Our people. Our money. Our work.
							</p>
						</div>

						<div
							className="home-hero-buttons"
							style={{
								display: "flex",
								alignItems: "center",
								gap: "12px",
								flexWrap: "wrap",
							}}
						>
							<a
								href="https://zikoramfb.qoreonline.com/onboarding/type"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									height: "clamp(40px, 3.61vw, 52px)",
									background: "#86C7A8",
									borderRadius: "8px",
									padding: "0 16px",
									fontFamily: "Raleway, sans-serif",
									fontWeight: 600,
									fontSize: "clamp(13px, 1.11vw, 16px)",
									lineHeight: "20px",
									color: "#132A22",
									textDecoration: "none",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									whiteSpace: "nowrap",
									boxSizing: "border-box",
								}}
							>
								Open Account
							</a>

							<a
								href="https://play.google.com/store/apps/details?id=com.clive.zikora"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									height: "clamp(40px, 3.61vw, 52px)",
									borderRadius: "8px",
									padding: "0 16px",
									fontFamily: "Raleway, sans-serif",
									fontWeight: 600,
									fontSize: "clamp(13px, 1.11vw, 16px)",
									lineHeight: "20px",
									color: "#FFFFFF",
									background: "transparent",
									border: "1px solid #DEDEDE",
									textDecoration: "none",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									whiteSpace: "nowrap",
									boxSizing: "border-box",
								}}
							>
								Download the App
							</a>
						</div>
					</div>

					<img
						className="home-hero-ndic"
						src={ndicFrame}
						alt="NDIC and CBN certified"
						style={{
							width: "clamp(160px, 23.3vw, 335px)",
							height: "auto",
							objectFit: "contain",
						}}
					/>
				</div>
			</section>
		</>
	);
};

export default HomeMain;
